import { render, staticRenderFns } from "./open-account.vue?vue&type=template&id=672c0831&scoped=true&"
import script from "./open-account.vue?vue&type=script&lang=js&"
export * from "./open-account.vue?vue&type=script&lang=js&"
import style0 from "./open-account.vue?vue&type=style&index=0&id=672c0831&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672c0831",
  null
  
)

export default component.exports